import { useState } from 'react';
import { PrimaryBtn } from '../Assets/Buttons';
import { Field, Label } from '../Assets/Fieldset';
import { Input } from '../Assets/Input';
import { Text, TextLink } from '../Assets/Text';

const ResetPasswordForm = (props) => {
  const [isValid, setIsValid] = useState(false);

  const validateEmail = (e) => {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      props.setEmail(e.target.value);
      setIsValid(emailRegex.test(e.target.value));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props.handleSubmit();
  };

  return (
    <form onSubmit={handleSubmit} className="grid w-full max-w-sm grid-cols-1 gap-6">
      <Field>
        <Label>Email address</Label>
        <Input 
          type="email"
          value={props.email}
          onChange={validateEmail}
          required
          aria-invalid={!isValid && props.email !== '' ? "true" : "false"}
          placeholder="your@email.com"
        />
        {props.email !== '' && !isValid && (
          <Text className="text-brand-red-500 text-sm mt-1">Please enter a valid email address.</Text>
        )}
      </Field>
      
      {props.err && (
        <Text className="text-brand-red-500">{props.err}</Text>
      )}

      <PrimaryBtn 
        type="submit" 
        disabled={!isValid}
        className="w-full"
      >
        Send Reset Code
      </PrimaryBtn>
      
      <Text>
        <TextLink href="/signin" onClick={(e) => {
          e.preventDefault();
          props.navigate('/signin');
        }}>
          Return to Sign In
        </TextLink>
      </Text>
    </form>
  );
};

export default ResetPasswordForm;